import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../../../api/generic/search/Request';

import { SearchDataTableType } from './SearchDataTableType';

export const WoHRecipeType = SearchDataTableType({
	request: BaseRequest({
		sortFields: constants.wholeHouse.recipe.sortFields,
		columnFields: constants.wholeHouse.recipe.columnFields,
		standardFilterFields: constants.wholeHouse.recipe.osStandardFilterFields,
		dateFilterFields: constants.wholeHouse.recipe.osDateFilterFields,
		stageStatusFilterFields: [] as const,
		booleanFilterFields: [] as const,
	}),
	columnFields: constants.wholeHouse.recipe.columnFields,
	filterIds: constants.wholeHouse.recipe.filterFields,
});
